<template>
  <button :style="btnStyle" @click="inverseValue" :title="title" :disabled="disabled">
    <slot>
      <i class="fas fa-eye" v-if="value"></i>
      <i class="far fa-eye-slash" v-else></i>
    </slot>
  </button>
</template>

<script>
export default {
  components: {  },
  props: ['value', 'title', 'disabled'],
  methods: {
    inverseValue() {
      this.$emit('input', !this.value)
    }
  },
  computed: {
    btnStyle() {
      return {
        border: '1px',
        'border-color': this.value ? '#ffa99a' : 'LightGray',
        'border-style': 'solid',
        'background-color': this.disabled ? 'LightGray' : 'white',
        'border-radius': '6px',
        'font-size': 'x-large',
        'margin-top': '6px',
        color: this.value ? 'tomato' : 'gray'
      }
    }
  }
}
</script>

<style scoped>
</style>
